<!-- <ul>
  <li [ngClass]="{'active': selectedTimeframe === 'month'}" (click)="selectTimeframe('month')"><a>Month</a></li>
  <li [ngClass]="{'active': selectedTimeframe === 'week'}" (click)="selectTimeframe('week')"><a>Week</a></li>
  <li [ngClass]="{'active': selectedTimeframe === 'day'}" (click)="selectTimeframe('day')"><a>Day</a></li>
</ul> -->

<div class="btn-group btn-group-main rounded-sm btn-group-timeframe" role="group">
  <button
    type="button"
    class="btn"
    *ngFor="let tf of tfs"
    [ngClass]="{ active: selectedTimeframe === tf }"
    (click)="selectTimeframe(tf)"
  >
    {{ tf | capitalize }}
  </button>
</div>
